var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-date",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentStyle === "countdown"
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-date-countdown",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-countdown-digit",
                              attrs: {
                                "data-countdown": "days",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-countdown-number",
                                },
                                [_vm._v(_vm._s(_vm.countdownDays))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownDays === "01",
                                      expression: "countdownDays === '01'",
                                    },
                                  ],
                                  staticClass: "cw-date-countdown-label-sg",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Tag")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownDays !== "01",
                                      expression: "countdownDays !== '01'",
                                    },
                                  ],
                                  staticClass: "cw-date-countdown-label-pl",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Tage")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-countdown-digit",
                              attrs: {
                                "data-countdown": "hours",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-countdown-number",
                                },
                                [_vm._v(_vm._s(_vm.countdownHours))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownHours === "01",
                                      expression: "countdownHours === '01'",
                                    },
                                  ],
                                  staticClass: "cw-date-countdown-label-sg",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Stunde")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownHours !== "01",
                                      expression: "countdownHours !== '01'",
                                    },
                                  ],
                                  staticClass: "cw-date-countdown-label-pl",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Stunden")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-countdown-digit",
                              attrs: {
                                "data-countdown": "minutes",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-countdown-number",
                                },
                                [_vm._v(_vm._s(_vm.countdownMinutes))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownMinutes === "01",
                                      expression: "countdownMinutes === '01'",
                                    },
                                  ],
                                  staticClass: "cw-date-countdown-label-sg",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Minute")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownMinutes !== "01",
                                      expression: "countdownMinutes !== '01'",
                                    },
                                  ],
                                  staticClass: "cw-date-countdown-label-pl",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Minuten")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-countdown-digit",
                              attrs: {
                                "data-countdown": "seconds",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-countdown-number",
                                },
                                [_vm._v(_vm._s(_vm.countdownSeconds))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownSeconds === "01",
                                      expression: "countdownSeconds === '01'",
                                    },
                                  ],
                                  staticClass: "cw-date-countdown-label-sg",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Sekunde")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownSeconds !== "01",
                                      expression: "countdownSeconds !== '01'",
                                    },
                                  ],
                                  staticClass: "cw-date-countdown-label-pl",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Sekunden")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStyle === "date"
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-date-date",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-date-digits",
                              attrs: {
                                "data-date": "date",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-date-number",
                                },
                                [_vm._v(_vm._s(_vm.currentDeDate))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "cw-date-date-space",
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-date-digits",
                              attrs: {
                                "data-date": "time",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-date-number",
                                },
                                [_vm._v(_vm._s(_vm.currentTime))]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Datum")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentDate,
                                  expression: "currentDate",
                                },
                              ],
                              attrs: {
                                type: "date",
                              },
                              domProps: {
                                value: _vm.currentDate,
                              },
                              on: {
                                change: _vm.computeTimestamp,
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentDate = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Uhrzeit")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentTime,
                                  expression: "currentTime",
                                },
                              ],
                              attrs: {
                                type: "time",
                              },
                              domProps: {
                                value: _vm.currentTime,
                              },
                              on: {
                                change: _vm.computeTimestamp,
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentTime = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Layout")) +
                                "\n                    "
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentStyle,
                                    expression: "currentStyle",
                                  },
                                ],
                                on: {
                                  change: function change($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.currentStyle = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "countdown",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Countdown")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "date",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Datum")))]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _vm._v(
                    _vm._s(_vm.$gettext("Informationen zum Termin-Block"))
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }